/* lua.js generated code 0.3.0 */

require("clover/data/UserManager")
require("clover/data/UserLocalSettings")
var Event = require("cocos/framework/components/event")
UserEnergy = xClass("UserEnergy", Event)
var instance = null
UserEnergy.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserEnergy.new()
    }
    return instance
}
UserEnergy.prototype.ctor = function () {
    var self = this
    self.lockedEnergy = 0
    // FIXME: LocalNotificationManager
    // LocalNotificationManager.getInstance().removeAllNotificationsByType(NotificationType.kEnergyFull)
}
UserEnergy.prototype.addEnergy = function (value) {
    var self = this
    self.refresh()
    var user = UserManager.getInstance().getUserRef()
    var energyLimit = self.getEnergyLimit()
    user.setEnergy(Math.min(user.getEnergy() + value, energyLimit))
    if (user.getEnergy() >= energyLimit) {
        user.setUpdateTime(Localhost.time())
    }
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserEnergy.prototype.consumeEnergy = function (value,levelId) {
    var self = this
    self.refresh()
    if (self.getEnergyInfinity()[0]) {
        return 
    }
    var user = UserManager.getInstance().getUserRef()
    var energyLimit = self.getEnergyLimit()
    if (user.getEnergy() >= energyLimit) {
        user.setUpdateTime(Localhost.time())
    }
    user.setEnergy(Math.max(user.getEnergy() - value, 0))
    // 新增精力消耗点位 在消耗的时候进行打点
    let pArr = table()
    table.insert(pArr, {itemId:4,num:value})
    DCAssist.dc4UseThings(pArr,null,{level:levelId},{},`${UserManager.getInstance().uid}_${Localhost.timeInSec()}`)

    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserEnergy.prototype.addEnergyInfinity = function (duration) {
    var self = this
    var userExtend = UserManager.getInstance().getUserExtendRef()
    var now = Localhost.time()
    var lastBuffTime = parseInt(userExtend.getNotConsumeEnergyBuff());
    if (lastBuffTime > now) {
        userExtend.setNotConsumeEnergyBuff(lastBuffTime + duration)
    } else {
        userExtend.setNotConsumeEnergyBuff(now + duration)
    }
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserEnergy.prototype.addEnergyLimit = function (value, expireTime) {
    var self = this
    var userExtend = UserManager.getInstance().getUserExtendRef()
    var now = Localhost.time()
    userExtend.setEnergyPlusEffectTime(expireTime)

    var normalEnergy = self.getBaseEnergyLimit()
    userExtend.setEnergyMaxCount(normalEnergy + value)

    if (expireTime > now){
        self.addEnergy(value)
    }
    // var lastBuffTime = parseInt(userExtend.getNotConsumeEnergyBuff());
    // if (lastBuffTime > now) {
    //     userExtend.setNotConsumeEnergyBuff(lastBuffTime + duration)
    // } else {
    //     userExtend.setNotConsumeEnergyBuff(now + duration)
    // }
    // if (NetworkConfig.writeLocalDataStorage) {
    //     Localhost.getInstance().flushCurrentUserData()
    // } else {
    //     cc.log("Did not write user data to the device.")
    // }
}
UserEnergy.prototype.lockEnergy = function (num) {
    var self = this
    self.lockedEnergy = Math.min(self.lockedEnergy + num, self.getEnergy()[0])
}
UserEnergy.prototype.unlockEnergy = function (num) {
    var self = this
    self.lockedEnergy = Math.max(self.lockedEnergy - num, 0)
}
UserEnergy.prototype.checkEnergy = function (value) {
    var self = this
    return self.getAvaliableEnergy()[0] >= value
}
UserEnergy.prototype.getEnergy = function () {
    var self = this
    self.refresh()
    var user = UserManager.getInstance().getUserRef()
    var energy = user.getEnergy()
    var limit = self.getEnergyLimit()
    var recoverTime = MetaManager.getInstance().global.user_energy_recover_time_unit || 480000
    if (energy < limit) {
        return [energy, recoverTime - Localhost.time() + user.getUpdateTime()]
    } else {
        return [energy, null]
    }
}
UserEnergy.prototype.getAvaliableEnergy = function () {
    var self = this
    if (self.getEnergyInfinity()[0]) {
        return [self.getEnergyLimit()]
    }
    var [energy, recoverTime] = self.getEnergy()
    return [Math.max(energy - self.lockedEnergy, 0), recoverTime]
}
UserEnergy.prototype.getEnergyInfinity = function () {
    var self = this
    var userExtend = UserManager.getInstance().getUserExtendRef()
    var energyInfiExpireTime = userExtend.getNotConsumeEnergyBuff()
    var now = Localhost.time()
    return [energyInfiExpireTime > now, energyInfiExpireTime > now && energyInfiExpireTime - now || null]
}
UserEnergy.prototype.getEnergyLimit = function () {
    var self = this

    let normalEnergy = self.getBaseEnergyLimit()
    let userExtend = UserManager.getInstance().getUserExtendRef()
    let energyPlusEffectTime = userExtend.getEnergyPlusEffectTime()
    let energyPlusLimit = userExtend.getEnergyMaxCount()
    let now = Localhost.time()
    if (energyPlusEffectTime > now) {
        return energyPlusLimit
    }else {
        return normalEnergy
    }
}
UserEnergy.prototype.getBaseEnergyLimit = function () {
    var self = this

    var normalEnergy = MetaManager.getInstance().global.user_energy_max_count || 30
    if (UserManager.getInstance().isVipMonth()) {
        normalEnergy += 5
    }
    return normalEnergy

}

UserEnergy.prototype.refresh = function () {
    var self = this
    var user = UserManager.getInstance().getUserRef()
    var energyLimit = self.getEnergyLimit()
    var energyInfi = self.getEnergyInfinity()[0]
    var now = Localhost.time()
    var energy = user.getEnergy()
    //if (energyInfi || energy >= energyLimit) {
        //user.setEnergy(energyLimit)
        //user.setUpdateTime(now)
    //} 
    //else {
        var duration = now - user.getUpdateTime()
        var recoverTime = MetaManager.getInstance().global.user_energy_recover_time_unit || 480000
        var energyInc = Math.floor(duration / recoverTime)
        let num = energyInc;
        if (energyInc + energy >= energyLimit) {
            num = energyLimit - energy;
            //console.log("@@@@energyInc:"+energyInc+" curEnergy:"+user.getEnergy()+" limit:"+energyLimit)
            user.setEnergy(energyLimit)
            user.setUpdateTime(now)
        } else if (energyInc >= 1) {
            //console.log("@@@@energyInc add:"+energyInc+" curEnergy:"+user.getEnergy()+" limit:"+energyLimit)
            user.setEnergy(energyInc + energy)
            user.setUpdateTime(user.getUpdateTime() + energyInc * recoverTime)
        }
        if(num >= 1){
            DCAssist.userTrack("energy_recharge","recharge_by_time", {
                session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
                num,
                t1: user.getEnergy(),
            })
        }
    //}
}
UserEnergy.prototype.onEnterForeground = function () {
    var self = this
    LocalNotificationManager.getInstance().removeAllNotificationsByType(NotificationType.kEnergyFull)
}
UserEnergy.prototype.onEnterBackground = function () {
    var self = this
    var energyLimit = self.getEnergyLimit()
    var [energy, remainTime] = self.getEnergy()
    var recoverTime = MetaManager.getInstance().global.user_energy_recover_time_unit || 480000
    var reviveTime = Math.max(0, (energyLimit - energy - 1) * recoverTime + (remainTime || 0))
    if (UserLocalSettings.getSetting("userenergy_enablenotify", false) && reviveTime > 30 * 60000) { // 30分钟
        var timeStamp = os.time() + Math.floor(reviveTime / 1000)
        var body = getText("notification.energy.full.body")
        var action = getText("notification.energy.full.action")
        LocalNotificationManager.getInstance().addNotification(NotificationType.kEnergyFull, timeStamp, body, action)
    }
}
// UserEnergy.prototype.updateEnergy = function () {
//     var self = this

//     function success(evt) {
//         if (evt && evt.data) {
//             // <property code="energy" type="int" desc="最新精力值" />
//             // <property code="updateTime" type="long" desc="上次修改时间" />
//             // <property code="energyPlusEffectTime" type="long" desc="精力上限提升截止时间" />
//             var user = UserManager.getInstance().getUserRef()
//             user.setEnergy(evt.data.energy)
//             user.setUpdateTime(evt.data.updateTime)

//             if (user.getEnergy() >= energyLimit) {
                
//             }
//             if (NetworkConfig.writeLocalDataStorage) {
//                 Localhost.getInstance().flushCurrentUserData()
//             } else {
//                 cc.log("Did not write user data to the device.")
//             }

//             self.updateInfo(evt.data)
//             self.checkIcon()
//             // self.info.leftTimes = 0
//             // self.dataLoaded = true
//         }
//         // else {
//         //     reject(evt)
//         // }
                    
//     }
//     let http = GetEnergyHttp.new()
//     http.addEventListener(Events.kComplete, success)
//     http.addEventListener(Events.kError, (evt) => {
//         // Toast.make(getText("error.tip."+ evt.data ))
//         // reject(evt)
//     })
//     http.addEventListener(Events.kCancel, () => {
//         // Toast.make(getText("error.tip."+ evt.data ))
//         // reject(0)
//     })
//     http.load()
// }
